module.exports = __webpack_public_path__ + "img/index_com_title.5cf0d3ac.png";